import { Stack } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import DisplayErrors from "src/components/display-errors";
import Iconify from "src/components/iconify/iconify";
import TruxAutocompleteField from "src/components/inputs/trux-autocomplete-field";
import TruxFormField from "src/components/inputs/trux-form-field";
import SimpleDialog from "src/components/simple-dialog";
import { ModelSavingData } from "src/hooks/use-model-saving-data";
import { EldDriver, EldEventLine } from "src/models";

type EldUnidentifiedLogModalProps = {
    selectedEldUnidentifiedLog: ModelSavingData<EldEventLine>,
    isOpen: boolean,
    setIsOpen: Dispatch<SetStateAction<boolean>>,
    updateEldEventLineUnidentified: VoidFunction,
    eldDrivers: EldDriver[],
  }

export function EldUnidetifiedEventLineModal(
    {selectedEldUnidentifiedLog, isOpen, setIsOpen, updateEldEventLineUnidentified, eldDrivers } : EldUnidentifiedLogModalProps

) {
    const selectedDriver = eldDrivers.find(d => d.id === selectedEldUnidentifiedLog?.model?.eldDriverId);

    return selectedEldUnidentifiedLog.model && <SimpleDialog
    title={"Update Unidentified Log"}
    open={isOpen}
    size="medium"
    onCancel={() => {
      setIsOpen(false);
    }}
    onSubmit={updateEldEventLineUnidentified}
    submitDisabled={selectedEldUnidentifiedLog.loading}
    submitButton={"Update Unidentified Log"}
    submitButtonIcon={<Iconify icon="basil:save-solid" />}
    submitButtonColor={"success"}>


    <DisplayErrors savingData={selectedEldUnidentifiedLog} />

    <Stack direction="column" gap={1}>

      <TruxFormField label="Driver *">
        <TruxAutocompleteField options={[...eldDrivers.map(driver => ({
            label: `${driver.firstName} ${driver.lastName}`,
            id: driver.id
            })), {
                label: "None",
                id: 0
            }]} 
            onClear={() => {
                selectedEldUnidentifiedLog.update(unidentifedLog => {
                    unidentifedLog.eldDriverId = 0;
                })
            }}
            onChange={(value) => {
                selectedEldUnidentifiedLog.update(unidetifiedLog => {
                    const driverId = value === null ? unidetifiedLog.eldDriverId : Number(value?.id);
                    unidetifiedLog.eldDriverId = driverId
                })
            }}
            selected={{
                id: selectedEldUnidentifiedLog.model.eldDriverId, 
                label: selectedEldUnidentifiedLog.model.eldDriverId === 0  ? "None" : `${selectedDriver?.firstName} ${selectedDriver?.lastName}`
            }}
        />
      </TruxFormField>
    </Stack>
</SimpleDialog>
}